@if (ability.can('read-sales-calendar', 'calendar')) {
  <div class="d-flex flex-column h-100 gap-3 overflow-hidden">
    <div class="row gy-3">
      <div class="col-lg-4 col-sm col-xl1-2 col-xxl-3">
        <generic-dropdown
          [items]="operatingUnits()"
          [label]="'Operating Unit'"
          [placeholder]="'Select'"
          [allowSearch]="true"
          [clearable]="true"
          [(ngModel)]="selectedOperatingUnitId"
          (ngModelChange)="selectedProject.set(null)"
        ></generic-dropdown>
      </div>

      <div class="col-lg-4 col-sm">
        <label class="form-label">Sales Office</label>
        <ng-select
          class="ng-select-md"
          [items]="groupedProjects()"
          placeholder="Select "
          bindValue="id"
          bindLabel="projectName"
          groupBy="salesOfficeName"
          [multiple]="true"
          [searchable]="true"
          [closeOnSelect]="false"
          [(ngModel)]="selectedProject"
        >
          <ng-template ng-optgroup-tmp let-item="item">
            <strong class="fw-500 text-black">{{ item.salesOfficeName }}</strong>
          </ng-template>
        </ng-select>
      </div>

      <!-- <generic-dropdown
      [items]="filteredProjects()"
      [label]="'Project'"
      [placeholder]="'Select'"
      [allowSearch]="true"
      [clearable]="true"
      [multiselect]="true"
      [(ngModel)]="selectedProject"
    ></generic-dropdown> -->

      <div class="col-auto col-md- ms-auto align-self-end">
        <button class="btn btn-primary btn-h42" (click)="onExportPDF()">
          <i class="bi bi-file-earmark-pdf fs-16"></i>
          Export PDF
        </button>
      </div>
    </div>
    <div class="flex-fill overflow-hidden">
      @if (hasProjects()) {
        <div class="row h-100">
          <div class="col-lg-3 col-xl1-2 sales-holidays">
            <div class="h-100 rounded-4 overflow-hidden bg-gray-200 d-flex flex-column">
              <div class="d-flex align-items-center gap-3 bg-white p-3">
                <i class="bi bi-folder fs-28"></i>
                <h3 class="mb-0">Projects</h3>
              </div>
              <div class="flex-fill h-100 overflow-hidden p-3">
                @if (projectsWithLots().length > 0) {
                  <div class="d-flex flex-column gap-3 h-100 me-n3 overflow-y-auto pe-2">
                    @for (project of projectsWithLots(); track project.projectId; let index = $index) {
                      <div
                        class="d-flex align-items-center bg-white rounded-3 p-3 box-project"
                        [style.--boxcolor]="projectColorMap.get(project.projectId)"
                      >
                        <div class="d-flex flex-column gap-1 flex-fill">
                          <div class="d-flex gap-2 mb-3 align-items-center">
                            <span class="fs-28 wh-24 rounded-5 circle col-auto box-icon"></span>
                            <h3 class="mb-0">{{ project.projectName }}</h3>
                          </div>
                          <div class="d-flex flex-wrap gap-2 flex-column fs-14">
                            <span class="fw-500 d-flex gap-2 align-items-center bg-light px-2 py-1 rounded-3"
                              >Target Closing:
                              <span class="fs-18 rounded-circle ms-auto d-flex-center me-2">{{
                                project.targetCount
                              }}</span></span
                            >
                            <span class="fw-500 d-flex gap-2 align-items-center bg-light px-2 py-1 rounded-3"
                              >Actual Closing:
                              <span class="fs-18 rounded-circle ms-auto d-flex-center me-2">{{
                                project.actualCount
                              }}</span></span
                            >
                          </div>
                        </div>
                      </div>
                    }
                  </div>
                } @else {
                  <div class="h-100 d-flex align-items-center justify-content-center flex-column gap-2 p-4">
                    <i class="bi bi-calendar-x fs-48 text-body-secondary"></i>
                    <p class="mb-0 text-center text-body-secondary">
                      <span class="fw-400">No project found</span>
                    </p>
                  </div>
                }
              </div>
            </div>
          </div>
          <div class="col-md h-100">
            <div class="d-flex flex-column h-100">
              <div class="flex-fill overflow-hidden">
                <div class="d-flex flex-column h-100 gap-3 overflow-hidden">
                  <div class="flex-fill overflow-auto bg-white rounded-4 p-3">
                    <app-full-calendar
                      (eventClick)="onEventClick($event)"
                      [showAllInCell]="false"
                      [events]="events()"
                      [allowDefaultMorePopup]="true"
                      (viewCenterDate)="onViewDateChange($event)"
                      (viewStartDate)="viewStartDate.set($event)"
                      (viewEndDate)="viewEndDate.set($event)"
                    ></app-full-calendar>
                    <div class="d-flex flex-column gap-2"></div>
                    <div class="d-flex justify-content-between align-items-center bg-light px-2 py-1 rounded-3">
                      <span class="fw-500">Year to Date Actual Closings:</span>
                      <span class="fs-18 rounded-circle ms-auto d-flex-center me-2">{{
                        ytdActualClosings().actualClosingsYtd
                      }}</span>
                    </div>
                    <div class="d-flex justify-content-between align-items-center bg-light px-2 py-1 rounded-3">
                      <span class="fw-500">Total Closed:</span>
                      <span class="fs-18 rounded-circle ms-auto d-flex-center me-2">{{ actualClosings() }}</span>
                    </div>
                    <div class="d-flex justify-content-between align-items-center bg-light px-2 py-1 rounded-3">
                      <span class="fw-500">Total Remaining:</span>
                      <span class="fs-18 rounded-circle ms-auto d-flex-center me-2">{{ targetClosings() }}</span>
                    </div>
                    <div class="d-flex justify-content-between align-items-center bg-light px-2 py-1 rounded-3">
                      <span class="fw-500">Total Closings:</span>
                      <span class="fs-18 rounded-circle ms-auto d-flex-center me-2">{{ totalClosings() }}</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      } @else {
        <div class="bg-white p-3 flex-fill overflow-hidden rounded-4 h-100">
          <div class="d-flex flex-column gap-3 align-items-center justify-content-center h-100">
            <i class="bi fs-72 lh-1 text-gray-300 bi-calendar3"></i>
            <p class="mb-0 fs-16 text-muted text-center">please select project to view information</p>
          </div>
        </div>
      }
    </div>
  </div>
}

<ng-template #dealDetailsModal let-modal>
  <div class="modal-header d-flex justify-content-between">
    <h1 class="modal-title">APS Details</h1>
    <span (click)="modal.dismiss()" role="button" class="ms-auto">
      <svg-icon [name]="'modal-close-menu'" class="svg-32"></svg-icon>
    </span>
  </div>
  <div class="modal-body">
    @if (selectedDeal()) {
      <div class="d-flex flex-column gap-2">
        <div class="d-flex justify-content-between gap-3">
          <span class="fw-500">Project</span>
          <span class="text-end">{{ selectedDeal()?.lot?.projectCode }}</span>
        </div>
        <div class="d-flex justify-content-between gap-3">
          <span class="fw-500">Lot</span>
          <span class="text-end">{{ selectedDeal()?.lot?.lotNo }}</span>
        </div>
        <div class="d-flex justify-content-between gap-3">
          <span class="fw-500">Model</span>
          <span class="text-end">
            {{ selectedDeal()?.lot?.selectedModel?.modelName || selectedDeal()?.model?.modelName }}
          </span>
        </div>
        <div class="d-flex justify-content-between gap-3">
          <span class="fw-500">Elevation</span>
          <span class="text-end">
            {{ selectedDeal()?.lot?.selectedElevation?.elevationCode || selectedDeal()?.elevation?.elevationCode }}
          </span>
        </div>
        <div class="d-flex justify-content-between gap-3">
          <span class="fw-500">Sales Agent</span>
          <span class="text-end">
            @if (linkedSalesAgentsResource.value().length) {
              {{ linkedSalesAgentsResource.value()![0].salesAgentName }}
            } @else {
              {{ selectedDeal()?.createdByUser }}
            }
          </span>
        </div>
        <form [formGroup]="form">
          <div class="col-xxl-12 col-xl-12 col-sm-12">
            <span class="fw-500">Closing Date</span>
            <p-datepicker
              formControlName="closingDate"
              [showIcon]="true"
              placeholder="Select date"
              styleClass="w-100"
              clearable="false"
              [iconDisplay]="'input'"
              appendTo="body"
              [baseZIndex]="9999"
              [showOnFocus]="false"
            />
          </div>
        </form>
        @if (!welcomeEmailStatus()) {
          <div class="alert alert-danger text-center">
            <i class="bi bi-exclamation-triangle fs-24"></i>
            Lot cannot be closed until welcome email is sent to the buyer.
          </div>
        }
      </div>
    } @else {
      <div class="py-2 text-muted">No APS details found.</div>
    }
  </div>
  <div class="modal-footer">
    <button type="button" class="btn btn-secondary btn-h45" (click)="modal.dismiss()">Cancel</button>
    @if (ability.can('mark-deal-closed', 'calendar')) {
      @if (welcomeEmailStatus()) {
        <button type="button" class="btn btn-primary btn-h45" (click)="markAsClosed()">Close Lot</button>
      }
    }
  </div>
</ng-template>
